import { createContext } from "react";

const SideMenuCommonFilterLib = createContext({});

export default SideMenuCommonFilterLib;
